/**
 * Styled components for AskHumanBox
 */

import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

/**
 * Container for Ask Human box at the bottom of sources panel
 */
export const AskHumanContainer = styled.div`
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  display: flex;
  align-items: flex-end;
`;

/**
 * Container for Ask Human box in transcript footer (no bottom padding)
 */
export const AskHumanContainerInFooter = styled.div`
  padding-bottom: 0;
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
`;

/**
 * Wrapper for Ask Human content
 */
export const AskHumanWrapper = styled.div`
  width: 100%;
`;

/**
 * Box containing Ask Human prompt and button (in vertical sources panel)
 */
export const AskHumanBoxContainer = styled.div`
  z-index: 10;
  max-height: fit-content;
  text-align: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  background-color: ${({ theme }) => (theme as IOcAppTheme).color.askHumanBg};
`;

/**
 * Box containing Ask Human prompt and button (in transcript footer)
 * No top border radius, connects directly to chat
 */
export const AskHumanBoxContainerInFooter = styled.div`
  z-index: 10;
  max-height: fit-content;
  text-align: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px;
  border-radius: 0 0 4px 4px;
  background-color: ${({ theme }) => (theme as IOcAppTheme).color.chatPanelBG || '#efefef'};
  color: ${({ theme }) => (theme as IOcAppTheme).color.chatHeading || '#000000'};
`;

/**
 * Prompt text for Ask Human ("Need opinions? AI can help you post.")
 */
export const AskHumanPrompt = styled.div<{ $inFooter?: boolean }>`
  font-size: ${({ theme }) => (theme as IOcAppTheme).font.size.small};
  color: ${({ theme }) => (theme as IOcAppTheme).color.askHumanPromptText
  };
  align-items: center;
  display: flex;
`;

